module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/north_america-77465924686da13109baf7faa78be7d5.png";